export default "__VITE_ASSET__ng6O2e4L__"